import React, { useState } from 'react';
import axios from 'axios';
import './FileSelectWithPreview.css';
import './ExampleFilePreview.css';

// A collapsible "view example format" disclosure. Fetches the preview lazily
// the first time it's expanded, so pages with several of these don't fire a
// batch of requests on mount.
export default function ExampleFilePreview({ label = 'View example format', previewUrl }) {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function toggle() {
    const next = !open;
    setOpen(next);
    if (next && !preview && !loading) {
      setLoading(true);
      setError(null);
      axios.get(previewUrl)
        .then(r => setPreview(r.data))
        .catch(e => setError(e.response?.data?.error || e.message))
        .finally(() => setLoading(false));
    }
  }

  return (
    <div className="example-file">
      <button type="button" className="example-toggle" onClick={toggle}>
        <span className={`example-chevron ${open ? 'open' : ''}`}>▸</span>
        {label}
      </button>
      {open && (
        <div className="fsp-preview example-preview">
          <div className="fsp-preview-header example-preview-header">
            Example
            {loading && <span className="fsp-preview-loading">Loading…</span>}
          </div>
          {error && <div className="fsp-preview-error">{error}</div>}
          {preview && (
            preview.rows.length === 0 ? (
              <div className="fsp-preview-empty">(empty file)</div>
            ) : (
              <div className="fsp-preview-table-wrap">
                <table className="fsp-preview-table">
                  <thead>
                    <tr>{preview.columns.map((c, i) => <th key={i}>{c}</th>)}</tr>
                  </thead>
                  <tbody>
                    {preview.rows.map((row, i) => (
                      <tr key={i}>{row.map((cell, j) => <td key={j}>{String(cell)}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}
